import React from "react";
import "./style/Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const updateHash = (highlight) => {
  document.location.hash = `highlight-${highlight.id}`;
};

const Sidebar = ({ highlights, isSidebarOpen, closeSidebar }) => {
  const hasComments = highlights.length > 0;

  return (
    <>
      {/* Backdrop for small screens */}
      {isSidebarOpen && <div className="backdrop" onClick={closeSidebar}></div>}

      <div
        className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}
        style={{ overflow: "visible" }} // Allow header to be seen outside
      >
        {/* Description section */}
        <div
          className="description"
          style={{
            padding: "0rem", // Reduced padding to move list up
            paddingBottom: "0rem",
            position: "relative", // Context for absolute header
          }}
        >
          <div
            className="comments-box"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem",
              fontFamily: "'Inter', sans-serif",
              position: "absolute",
              top: "-30px", // Align with Tabs height (approx 40-48px)
              left: 0,
              width: "100%",
              zIndex: 100, // Ensure it's on top
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Center the title
                width: "100%",
                alignItems: "center",
                position: "relative", // For absolute positioning of close icon
              }}
            >
              <h3
                className="comments"
                style={{
                  margin: "0px",
                  textAlign: "center",
                  color: "#114a6d",
                  fontWeight: "bold",
                }}
              >
                Comments
              </h3>
              <FontAwesomeIcon
                icon={faClose}
                className="humburger"
                onClick={closeSidebar}
                style={{
                  marginLeft: "5px",
                  position: "absolute",
                  right: "0",
                  cursor: "pointer",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        {/* Highlights list */}
        {hasComments ? (
          <ul
            className="sidebar__highlights"
            style={{ overflowY: "auto", height: "calc(100% - 20px)" }} // Ensure scrolling works if main overflow is visible
          >
            {highlights.map((highlight, index) => (
              <li
                key={index}
                className="sidebar__highlight"
                onClick={() => {
                  updateHash(highlight);
                }}
              >
                <div>
                  {/* Highlight comment and text */}

                  {highlight.content.text && (
                    <blockquote style={{ marginTop: "0.5rem" }}>
                      {`${highlight.content.text.slice(0, 90).trim()}…`}
                    </blockquote>
                  )}

                  {/* Highlight image */}
                  {highlight.content.image && (
                    <div
                      className="highlight__image__container"
                      style={{ marginTop: "0.5rem" }}
                    >
                      <img
                        src={highlight.content.image}
                        alt={"Screenshot"}
                        className="highlight__image"
                      />
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    marginTop: "1rem",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <div className="comments-container">
                    <p className="valuable-com">
                      Your valuable comments are displayed below.
                    </p>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: highlight.comment || "",
                      }}
                      style={{ wordWrap: "break-word" }}
                    />
                  </div>

                  <div className="highlight__location">
                    Page {highlight.position.boundingRect.pageNumber}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ textAlign: "center", marginTop: "10px" }}>
            No comments found
          </p>
        )}
      </div>
    </>
  );
};

export default Sidebar;
